import Swal from "sweetalert2";
import { OptionalConfirmation } from "../utils/OptionalConfirmation";
import { showErrorReportButton } from "../utils/showErrorReportButton";
import twigVariables from "../utils/twigVariables";
import { uppercaseFirstletter } from "../utils/uppercase-firstletter";
import { AddressAutocompletion } from "./address-autocompletion";
import CheckUserExists from "./check-user-exists";
import warnDomains from "./warn-domains";

const twigVars = twigVariables();
const surname = document.getElementById(twigVars.surnameid);
const firstname = document.getElementById(twigVars.nameid);
const birthdate = document.getElementById(twigVars.birthdateid);
const birthplace = document.getElementById(twigVars.birthplaceid);
const companyname = document.getElementById(twigVars.companynameid);
const label = surname.parentElement.parentElement.querySelector("label");
const hideForAdminElements = document.querySelectorAll(".hide-for-admin");
const customAgs = document.getElementById("customAgs");
const customAgsSelect = document.getElementById("app_usertype_customAgs");

const isAndroid = /(android)/i.test(navigator.userAgent);
const dateHelp = document.querySelector("#registration_form_birthdate_help");
if (dateHelp && !isAndroid) {
	dateHelp.classList.add("hide");
}

// Caching
const $company = $("#company");
let toggleCount = 0;

warnDomains("#registration_form_email_first", [
	"aol.com",
	"yahoo.com",
	"gmail.com",
	"googlemail.de",
	"hotmail.com",
]);

const optionalConfirmation = new OptionalConfirmation(
	twigVars.confirmoptionalid,
);

const hideCompanyRelated = () => {
	$company
		.hide("normal")
		.find("input")
		.prop("required", false)
		.end()
		.find("label")
		.removeClass("required");
	$(".hide-for-company")
		.find("input")
		.prop("required", true)
		.end()
		.find("label")
		.addClass("required")
		.end()
		.show("normal");
	label.innerHTML = label.innerHTML.replace("Ansprechperson", "Nachname");

	if (companyname) {
		companyname.value = "";
	}
};

const showCompanyRelated = () => {
	$company
		.find("input")
		.prop("required", true)
		.end()
		.find("label")
		.addClass("required")
		.end()
		.show("normal");
	$(".hide-for-company")
		.hide("normal")
		.find("input")
		.prop("required", false)
		.end()
		.find("label")
		.removeClass("required");
	label.innerHTML = label.innerHTML.replace("Nachname", "Ansprechperson");

	firstname.value = "";
	if (birthdate) {
		birthdate.value = "";
	}
	if (birthplace) {
		birthplace.value = "";
	}
};

// Ersten Buchstaben großschreiben
uppercaseFirstletter(
	`#${twigVars.surnameid},#${twigVars.nameid},#${twigVars.cityid},#${twigVars.streetid},#${twigVars.companynameid}${twigVars.birthplaceid !== null ? `,#${twigVars.birthplaceid}` : ""}`,
);

new AddressAutocompletion(
	document.getElementById(twigVars.zipid),
	document.getElementById(twigVars.streetid),
	document.getElementById(twigVars.cityid),
	document.getElementById(twigVars.districtid),
	document.getElementById(twigVars.housenumberid),
	document.getElementById(twigVars.addressadditionid),
	document.getElementById("locationResults"),
	document.getElementById("addressStatus"),
	twigVars.csrf,
	(isValid) => {
		if (customAgs !== null) {
			customAgs.classList.toggle("hidden", isValid);
			if (isValid) {
				customAgsSelect.selectedIndex = -1;
			}
		}
	},
	document.getElementById("app_usertype_skipAddressValidation"),
);

if (twigVars.companyid !== "null") {
	// Required-Felder für Juristische Person togglen
	$(`#${twigVars.companyid}`)
		.change(function () {
			if ($(this).prop("checked")) {
				showCompanyRelated();
			} else {
				hideCompanyRelated();
			}
			const checkbox = document.getElementById("registration_form_company");
			if (checkbox && toggleCount >= 1) {
				checkbox.focus();
			}
			toggleCount++; // Hack: Erstes togglen durch Laden der Seite überspringen
		})
		.trigger("change");
} else {
	showCompanyRelated();
}

if (twigVars.offlineid !== "null") {
	// jQ Form Caching
	const $offline = $(`#${twigVars.offlineid}`);
	const offlineRelated = $(".offline-related").parents(".form-group");
	const offlineRelatedItems = document.querySelectorAll(".offline-related");
	const onlineRelated = $(".online-related").parents(".form-group");
	const onlineRelatedItems = document.querySelectorAll(".online-related");
	const requiredForUserLabels = $(".required-for-user")
		.parents(".form-group")
		.find("label");
	const requiredForUserInput = $(".required-for-user")
		.parents(".form-group")
		.find("input, select");

	const requiredForAdminLabels = $(".required-for-admin")
		.parents(".form-group")
		.find("label");
	const requiredForAdminInput = $(".required-for-admin")
		.parents(".form-group")
		.find("input");

	const emailLabel = $(`#${twigVars.emailid}`)
		.parents(".form-group")
		.find("label");
	const $roles = $(`#${twigVars.roleid}`);

	/**
	 * Felder für Offline-/Onlinekonten unterschiedlich
	 */
	const toggleOfflineRelated = () => {
		if ($offline.prop("checked")) {
			generateUsername();
			emailLabel.text("Benutzername");
			const emailError = document.getElementById(`${twigVars.emailid}_errors`);
			if (emailError) {
				emailError.getElementsByTagName("p")[0].innerText =
					"Dieser Benutzername wird bereits verwendet.";
			}

			offlineRelated.show("normal");
			onlineRelated.hide("normal");
			for (const item of onlineRelatedItems) {
				clearInputs(item);
			}
			$roles.val("ROLE_USER");
			$(`#${twigVars.emailid}`)
				.attr(
					"title",
					"Die Benutzerkennung wird nach Eingabe vom Nachnamen und Geburtsdatum automatisch gebildet.",
				)
				.tooltip({
					placement: "right",
					trigger: "focus",
				});
		} else {
			emailLabel.text("E-Mail-Adresse");
			offlineRelated.hide("normal");
			for (const item of offlineRelatedItems) {
				clearInputs(item);
			}
			onlineRelated.show("normal");
			$(`#${twigVars.emailid}`).removeAttr("title").tooltip("destroy");
		}
	};

	/**
	 * Benutzernamen für Offlinekontos generieren
	 */
	const generateUsername = () => {
		if (twigVars.entityusername === "") {
			if ($offline.prop("checked")) {
				const bd = $(`#${twigVars.birthdateid}`).val().split("-");

				if (bd.length !== 3) return;

				// Nachname + Geburtsjahr
				$(`#${twigVars.emailid}`).val(
					$(`#${twigVars.surnameid}`).val() + bd[0],
				);
			}
		}
	};

	$(`#${twigVars.surnameid}, #${twigVars.birthdateid}`).on("change", () => {
		generateUsername();
	});

	/**
	 * Pflichtfelder für die verschiedenen Rollen wechseln
	 */
	const toggleRequired = () => {
		if ($roles.val() === "ROLE_USER" || $offline.prop("checked")) {
			// Pflichtfelder für Halter oder Offline-Konten

			requiredForUserInput.prop("required", true);
			requiredForUserLabels.addClass("required");

			requiredForAdminInput.prop("required", false);
			requiredForAdminLabels.removeClass("required");

			$(".required-for-admin").parents(".form-group").hide("normal");
			for (const element of hideForAdminElements) {
				element.classList.remove("hidden");
			}
			$(`#${twigVars.companyid}`).trigger("change");
		} else {
			// Pflichtfelder für Adminkonten

			hideCompanyRelated();

			requiredForUserInput.prop("required", false);
			requiredForUserLabels.removeClass("required");
			for (const element of hideForAdminElements) {
				element.classList.add("hidden");
			}
			$(".required-for-admin").parents(".form-group").show("normal");
			requiredForAdminInput.prop("required", true);
			requiredForAdminLabels.addClass("required");
		}

		if ($roles.val() === "ROLE_SUPER_ADMIN") {
			$(".hide-for-non-admin").show("normal");
		} else {
			$(".hide-for-non-admin").hide("normal");
		}

		// Sichtbarkeit des confirmOptional-Felds hat sich vielleicht geändert
		optionalConfirmation.onInput();
	};

	function clearInputs(item) {
		if (item.type === "checkbox") {
			item.checked = false;
		} else {
			item.value = "";
		}
	}

	$roles.change(() => {
		toggleRequired();
	});

	toggleOfflineRelated();

	$offline.change(() => {
		toggleOfflineRelated();
		toggleRequired();
	});

	// Organisation aus Hash vorbelegen
	if (location.hash.indexOf("organization") !== -1) {
		const orga = location.hash.substring(1).split("=")[1];
		$(`#${twigVars.organizationid}`).val(orga);
	}

	toggleRequired();
}

// Wenn ROLE_SUPER_ADMIN
if (twigVars.sa === "true") {
	new CheckUserExists(
		twigVars.checkuserexistsurl,
		document.getElementById("checkUserExistsResultWrapper"),
		document.getElementById(twigVars.nameid),
		document.getElementById(twigVars.surnameid),
		document.getElementById(twigVars.birthdateid),
		document.getElementById(twigVars.birthplaceid),
		twigVars.uuid,
	);

	const saveButton = document.getElementById("saveButton");
	if (saveButton !== null) {
		saveButton.addEventListener("click", () => {
			const form = saveButton.closest("form");
			if (!form.checkValidity()) {
				showErrorReportButton(twigVars.reportusererrorpath);
			}
		});
	}

	if ($(".form-horizontal").find(".form-group.has-error").length > 0) {
		showErrorReportButton(twigVars.reportusererrorpath);
	}
}

async function confirmOptionalFields() {
	return new Promise((resolve) => {
		Swal.fire({
			title: "Optionale Angaben",
			html:
				"<p>Bitte bestätigen Sie das Speichern Ihrer freiwilligen Angaben. " +
				"Ansonsten werden nur Pflichtangaben gespeichert.</p>",
			showCancelButton: true,
			confirmButtonText: "Speichern ohne freiwillige Angaben",
			cancelButtonText: "Angaben ändern",
			icon: "info",
		}).then((confirm) => {
			resolve(confirm.value);
		});
	});
}

const userForm = document.querySelector("#main form");

if (userForm instanceof HTMLFormElement) {
	userForm.addEventListener("submit", async (event) => {
		event.preventDefault();

		if (
			optionalConfirmation.needsOptionalConfirmation() &&
			!optionalConfirmation.hasConfirmation() &&
			!(await confirmOptionalFields())
		) {
			// evtl. gesperrte Submit-Buttons wieder freigeben
			const submitButtons = userForm.querySelectorAll(
				'[type="submit"]:not(.multiple-submit)',
			);
			for (const submitButton of submitButtons) {
				submitButton.disabled = false;
			}
			return;
		}

		userForm.submit();
	});
}
